import React, { useContext, useEffect, useState } from "react";
import { GiReceiveMoney } from "react-icons/gi";
import { refreshToken } from "../../../Actions/Auth";
import { getSpecificWidget } from "../../../Actions/WholeSale/HomePage";
import SeeAllButton from "../Buttons/SeeAllButton";
import { usersData } from "../../../App";
import ErrorModal from "../../Modals/ErrorModal";
import OrderMessageModal from "../../Modals/orderMessageModal";
import WholeSaleProductCard2 from "../WholeSaleProductCard/WholeSaleProductCard2";
import { useNavigate } from "react-router";

function FastMovingProducts({ data }) {
  const [fastMovingProductData, setFastMovingProductData] = useState([]);
  const [errorModal, setErrorModal] = useState({ show: false, content: "" });
  const { userData, setShowMaintenance } = useContext(usersData);
  const [infoMessage, setInfoMessage] = useState({
    show: false,
    content: "",
    subContent: "",
    header: "",
  });
  const navigate = useNavigate()
  const [shimmer, setShimmer] = useState(false)

  const getFastMovingProductData = async () => {
    let url = data?.data?.apiEndPoint;
    //update the shimmer state
    setShimmer(true)

    try {
      const res = await getSpecificWidget(url);
      setFastMovingProductData(res?.data?.data?.medicineResponseList === null ? [] : res?.data?.data?.medicineResponseList);
      //update the shimmer state
      setShimmer(false)
    } catch (error) {
      //reset shimmer if any error
      setShimmer(false)

      if (error?.response?.status === 401) {
        refreshToken().then((res) => {
          getFastMovingProductData();
        });
      } else if (
        error?.response?.status === 502 ||
        error?.response?.status === 503 ||
        error?.response?.status === 504
      ) {
        setShowMaintenance(true);
      } else if (error?.response?.status === 500) {
        setErrorModal({
          show: true,
          content: "Oops something went wrong!",
          tryAgain: function () {
            getFastMovingProductData();
          },
        });
      } else if (error?.response?.status === 400) {
        setInfoMessage({
          show: true,
          content: error?.response?.data?.error?.localizedMessage,
          header: "INFO",
        });
      } else {
        setErrorModal({
          show: true,
          content: error?.response?.data?.error?.error
            ? error.response.data.error.error
            : "Something went wrong!",
          tryAgain: function () {
            getFastMovingProductData();
          },
        });
      }
    }
  };

  const handleSeeAllProducts = () => {
    navigate('/wholesale/fastMovingProducts')
  }

  //onMount
  useEffect(() => {
      getFastMovingProductData()
  },[])

  return (
    <>
      <ErrorModal
        show={errorModal.show}
        content={errorModal.content}
        onHide={() => {
          setErrorModal({
            show: false,
            content: "",
          });
        }}
        tryAgain={() => {
          errorModal?.tryAgain();
          setErrorModal({ show: false, content: "" });
        }}
      />
      <OrderMessageModal
        show={infoMessage.show}
        content={infoMessage.content}
        header={infoMessage.header}
        onHide={() => {
          setInfoMessage({ show: false, content: "", header: "" });
        }}
      />
      {!shimmer && fastMovingProductData?.length > 0 && (
      <div className="tsp-main-container">
        <div className="tsp-header-wrapper">
          <div className="tsp-header font_ubuntu">
            <GiReceiveMoney size="1.5rem" color="#1A4059" />
            <span
              className="font_weight_md"
              style={{ fontSize: ".9rem", color: "#1A4059" }}
            >
              {data?.data?.title}
            </span>
          </div>
          <SeeAllButton onClick={handleSeeAllProducts}/>
        </div>
        <div className="wholesale-product-card-wrapper">
            {fastMovingProductData?.map((item, index) => {
                return <WholeSaleProductCard2 data={item} key={index} customCss='fmp-card' />
            })}
        </div>
      </div>
      )}

      {shimmer && fastMovingProductData?.length === 0 &&(
         <div className="tsp-main-container">
         <div className="tsp-header-wrapper">
           <div className="tsp-header font_ubuntu">
             <GiReceiveMoney size="1.5rem" color="#1A4059" />
             <span
               className="font_weight_md"
               style={{ fontSize: ".9rem", color: "#1A4059" }}
             >
               {data?.data?.title}
             </span>
           </div>
           <SeeAllButton/>
         </div>
         <div className="wholesale-product-card-wrapper">
             {[...Array(5)].map((_, index) => {
                 return <WholeSaleProductCard2 key={index} customCss='fmp-card' shimmer={true} />
             })}
         </div>
       </div>
      )}
    </>
  );
}

export default FastMovingProducts;
